export const ROOT_STORE_PATH = 'claims/'
export const CLAIM_STORE_PATH = 'claims/claim/'
export const ADMIN_SETUP_PATH = 'claims/adminSetup/'
export const ASSIGN_CLAIMS_PATH = 'claims/assignClaims/'
export const MOCK_POLICIES_MAINTENANCE_PATH = 'claims/adminSetup/mockPoliciesMaintenance/'
export const UI_CONFIG_PATH = 'claims/adminSetup/uiConfig/'
